import React from "react";
import PropTypes from "prop-types";
import Table from "../components/common/table";
import MissionGroupName from "../components/common/MissionGroupName";
import { useI18n } from "../i18n/LanguageContext";

const PlayTable = ({ plays, onSort, selectedSort, ...rest }) => {
  const { t } = useI18n();
  const columns = {
    nickname: {
      path: "missions",
      name: t("play.missions"),
      component: (play) => <MissionGroupName id={play.missionId} />,
    },
    secret: {
      name: t("play.secret"),
      component: (play) => (
        <div className="flex justify-center">{play.secret}</div>
      ),
    },
    win: {
      name: t("play.results"),
      component: (play) => (
        <div className="flex justify-center">
          {play.win === undefined ? (
            <div>{t("play.inProgress")}</div>
          ) : play.win ? (
            <div className="text-green-300">{t("play.win")}</div>
          ) : (
            <div className="text-red-300">{t("play.lose")}</div>
          )}
        </div>
      ),
    },
  };
  return (
    <Table
      onSort={onSort}
      selectedSort={selectedSort}
      columns={columns}
      data={plays}
    />
  );
};

PlayTable.propTypes = {
  plays: PropTypes.array.isRequired,
  onSort: PropTypes.func.isRequired,
  selectedSort: PropTypes.object.isRequired,
};

export default PlayTable;
